import { authenticatedFetch } from "./http";

export type GlobalSearchType =
  "ASN" | "RECEIPT" | "HANDLING_UNIT" | "PRODUCT" | "LOCATION" |
  "OUTBOUND_ORDER";

export interface GlobalSearchResult {
  type: GlobalSearchType;
  id: string;
  reference: string;
  title: string;
  context: string;
  status: string;
  view: "inbound" | "stock" | "products" | "warehouse" | "outbound-orders";
  searchTerm: string;
}

export function loadGlobalSearch(
  query: string,
  limit = 20
): Promise<GlobalSearchResult[]> {
  const params = new URLSearchParams({ q: query, limit: String(limit) });
  return authenticatedFetch<GlobalSearchResult[]>(
    `/api/v1/search?${params.toString()}`
  );
}
